export const ReasonCode = {
  CORONAVIRUS_SUSPICION_APPT_REASON_CODE: "VisitType:coronavirusSuspicion",
  FOR_DEV_TESTING_ONLY: "FOR_DEV_TESTING_ONLY",
} as const;

export const apptReasonEntityCodesToHide: string[] = [
  ReasonCode.CORONAVIRUS_SUSPICION_APPT_REASON_CODE,
  ReasonCode.FOR_DEV_TESTING_ONLY,
];
